import { client } from './client/client.gen';
import { environment } from './environments/environment';

/**
 * Configure the Hey API generated client.
 *
 * Keep this call in `main.ts` so all generated SDK/query helpers share
 * the same base URL and credential strategy.
 *
 * `apiBaseUrl` is intentionally empty in normal app configurations so browser
 * requests stay same-origin (`/api/...`) and are proxied by the dev server
 * (ng serve) or SSR server (Express runtime).
 */
export function configureApiClient(): void {
  client.setConfig({
    baseUrl: environment.apiBaseUrl,
    credentials: 'include',
  });
}
